/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Tips from "./Tips";

/* Render Tips app into the pug template */
function render(props) {
  hydrate(<Tips {...props} />, document.getElementById("react"));
}

render(window.reactProps);
